/**
 * This removes Relay's `'% future added value'` type from a string union.
 *
 * This should be rarely used. Instead consider the relevant operation type from `@/types/api`.
 */
export type ExcludeRelayFutureAddedValue<T> = Exclude<T, '%future added value'>;

/**
 * WARNING: This utility does not guarantee runtime safety to guarantee an exact type match.
 * ie. Your resulting returned array _could_ have additional keys not in the definition.
 */
export const getTypedKeys = <T extends Record<string, unknown>>(
  object: T,
): Array<keyof T> => {
  return Object.keys(object);
};

/**
 * @see https://fettblog.eu/typescript-array-includes/
 */
export const includes = <C extends M, M>(
  collection: readonly C[],
  member: M,
): member is C => {
  return collection.includes(member as C);
};

/**
 * Transforms a string to a camel case.
 */
export type CamelToSnakeCase<S extends string> =
  S extends `${infer T}${infer U}`
    ? `${T extends Capitalize<T>
        ? '_'
        : ''}${Lowercase<T>}${CamelToSnakeCase<U>}`
    : S;
